import axios from 'axios'

const commons = {
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  validateStatus: function (status) {
    // carefull! most requests use status > 300 for failures
    return (status >= 200 && status <= 300) || [404].includes(status)
  }
}

export const api = axios.create({
  baseURL: '/custom',
  ...commons
})

export const print = axios.create({
  baseURL: '/print',
  ...commons
})
